module.exports = __webpack_public_path__ + "img/banco-do-nordeste.2256350d.svg";